function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useMemo, useState } from 'react';
import { Provider } from 'react-redux';
import { store } from '@deephaven/redux';
import '@deephaven/components/scss/BaseStyleSheet.scss';
import { ClientBootstrap } from '@deephaven/jsapi-bootstrap';
import { useBroadcastLoginListener } from '@deephaven/jsapi-components';
import { ContextActions, ContextMenuRoot, FontBootstrap, FontsLoaded } from '@deephaven/components';
import PluginsBootstrap from "./PluginsBootstrap.js";
import AuthBootstrap from "./AuthBootstrap.js";
import ConnectionBootstrap from "./ConnectionBootstrap.js";
import { getConnectOptions, createExportLogsContextAction } from "../utils/index.js";
import UserBootstrap from "./UserBootstrap.js";
import ServerConfigBootstrap from "./ServerConfigBootstrap.js";
import ThemeBootstrap from "./ThemeBootstrap.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * AppBootstrap component. Handles loading the fonts, client, and authentication.
 * Will display the children when everything is loaded and authenticated.
 */
export function AppBootstrap(_ref) {
  var fontClassNames = _ref.fontClassNames,
    pluginsUrl = _ref.pluginsUrl,
    getCorePlugins = _ref.getCorePlugins,
    serverUrl = _ref.serverUrl,
    logMetadata = _ref.logMetadata,
    children = _ref.children;
  var clientOptions = useMemo(() => getConnectOptions(), []);

  // On logout, we reset the client and have user login again
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    logoutCount = _useState2[0],
    setLogoutCount = _useState2[1];
  var onLogin = useCallback(() => undefined, []);
  var onLogout = useCallback(() => {
    requestAnimationFrame(() => {
      setLogoutCount(value => value + 1);
    });
  }, []);
  useBroadcastLoginListener(onLogin, onLogout);
  var contextActions = useMemo(() => [createExportLogsContextAction(logMetadata, true)], [logMetadata]);
  return /*#__PURE__*/_jsxs(Provider, {
    store: store,
    children: [/*#__PURE__*/_jsx(FontBootstrap, {
      fontClassNames: fontClassNames,
      children: /*#__PURE__*/_jsx(PluginsBootstrap, {
        getCorePlugins: getCorePlugins,
        pluginsUrl: pluginsUrl,
        children: /*#__PURE__*/_jsx(ThemeBootstrap, {
          children: /*#__PURE__*/_jsxs(ClientBootstrap, {
            serverUrl: serverUrl,
            options: clientOptions,
            children: [/*#__PURE__*/_jsx(AuthBootstrap, {
              children: /*#__PURE__*/_jsx(ServerConfigBootstrap, {
                children: /*#__PURE__*/_jsx(UserBootstrap, {
                  children: /*#__PURE__*/_jsx(ConnectionBootstrap, {
                    children: /*#__PURE__*/_jsx(FontsLoaded, {
                      children: children
                    })
                  })
                })
              })
            }), /*#__PURE__*/_jsx(ContextActions, {
              actions: contextActions
            })]
          }, logoutCount)
        })
      })
    }), /*#__PURE__*/_jsx(ContextMenuRoot, {})]
  });
}
export default AppBootstrap;
//# sourceMappingURL=AppBootstrap.js.map